export const LOAD_QUESTS = 'LOAD_QUESTS';
export const NEXT_QUEST = 'NEXT_QUEST';
export const PREV_QUEST = 'PREV_QUEST';
